import { selectACSPattern } from '../utilities/selectACSPattern';
/**
 * Return
 * @param {*} signal
 */
export function signalMultiplicityPattern(signal, options) {
    const js = signal.js;
    let pattern = '';
    if (js && js.length > 0) {
        for (const coupling of js) {
            const { multiplicity = '' } = coupling;
            pattern += options?.acsFormat
                ? selectACSPattern(multiplicity)
                : multiplicity;
        }
    }
    else if (signal.delta) {
        pattern = '';
    }
    else {
        pattern = 'm';
    }
    return pattern;
}
//# sourceMappingURL=signalMultiplicityPattern.js.map